// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__27MUV","buttons":"SendReceipts_buttons__3L4-k","email":"SendReceipts_email__1-9yp","bookApptTitle":"SendReceipts_bookApptTitle__2LobG"};